export default "__VITE_PUBLIC_ASSET__54c895b0__"